import i18n from '../i18n';
import { store } from '../store';

/**
 * Il testo di una chiave nella lingua scelta dall'utente, da usare nello
 * script di un componente.
 *
 * **Perche' non il `t` di `useI18n()`.** vue-i18n qui gira in modalita'
 * legacy, e quel `t` legge il secondo argomento stringa come *messaggio di
 * default*, non come locale: `t(key, store.state.locale)` esce nella lingua
 * globale, che dopo l'avvio non viene mai aggiornata (Settings cambia solo lo
 * store). Il `$t` del template invece onora il locale, e mischiare le due
 * strade fa uscire titolo e corpo dello stesso messaggio in lingue diverse.
 *
 * `i18n.global` in modalita' legacy e' l'istanza che il `$t` del template
 * usa per i componenti senza un blocco `i18n` proprio: questa funzione dice
 * quindi esattamente cio' che direbbe `$t(key, $store.state.locale)`.
 */
export const localeText = (key) => i18n.global.t(key, store.state.locale);

export default localeText;
